import DemantCompatibilityGuide from '@demant/pim-compatibility-guide/lib/component/demant-pim-compatibility-guide';
import ReactDOM from 'react-dom';
import React from 'react';
import App from './app';
var compatibilityGuide = new DemantCompatibilityGuide();
compatibilityGuide.onRender = function (_ref) {
  var component = _ref.component,
    loadContent = _ref.loadContent,
    settings = _ref.settings;
  ReactDOM.render(/*#__PURE__*/React.createElement(App, {
    settings: settings,
    loadContent: loadContent
  }), component.querySelector('.component-content'));
};
compatibilityGuide.run();